<div
	class="tabContent tabContentForRoomGroup"
	#canvasContainer
	style="width: 100%; height: 100%"
	[id]="'canvasContainer' + trainingRoomGroupIndex"
></div>
<div class="controlsContainer">
	@if (!readOnly) {
		<div class="topButtons">
			@if (trainingRoomGroup?.id) {
				<button
					(click)="uploadBackgroundImageClicked(trainingRoomGroup)"
					mat-mini-fab
					color="accent"
					matTooltip="{{ T.SHARED_TRAINING_ROOM_NAVIGATION_UPLOAD_BACKGROUND_IMAGE | translate }}"
					matTooltipClass="accent"
					[@zoomInOnEnter]
					[@zoomOutOnLeave]
				>
					<mat-icon fontSet="fas" inline fontIcon="fa-upload" />
				</button>
			}
			@if (trainingRoomGroup.id) {
				<button
					(click)="zoomInBackground(trainingRoomGroup)"
					mat-mini-fab
					color="accent"
					matTooltip="{{ T.SHARED_TRAINING_ROOM_NAVIGATION_ZOOM_IN | translate }}"
					matTooltipClass="accent"
					[disabled]="!trainingRoomGroup.blueprintMediaId"
					[@zoomInOnEnter]
					[@zoomOutOnLeave]
				>
					<mat-icon fontSet="fas" inline fontIcon="fa-plus" />
				</button>
			}
			@if (trainingRoomGroup.id) {
				<button
					(click)="zoomOutBackground(trainingRoomGroup)"
					mat-mini-fab
					color="accent"
					matTooltip="{{ T.SHARED_TRAINING_ROOM_NAVIGATION_ZOOM_OUT | translate }}"
					matTooltipClass="accent"
					[disabled]="!trainingRoomGroup.blueprintMediaId"
					[@zoomInOnEnter]
					[@zoomOutOnLeave]
				>
					<mat-icon fontSet="fas" inline fontIcon="fa-minus" />
				</button>
			}
			<button
				(click)="resetRoomPositions(trainingRoomGroup)"
				mat-mini-fab
				color="accent"
				matTooltip="{{ T.SHARED_TRAINING_ROOM_NAVIGATION_RESET_ROOM_POSITIONS | translate }}"
				matTooltipClass="accent"
				[@zoomInOnEnter]
				[@zoomOutOnLeave]
			>
				<mat-icon fontSet="fas" inline fontIcon="fa-undo" />
			</button>
		</div>
	}
	<button
		class="helpButton"
		mat-mini-fab
		matTooltip="{{ T.SHARED_TRAINING_ROOM_NAVIGATION_PLAN_VIEW_HINT | translate }}"
		matTooltipPosition="left"
		matTooltipClass="accent"
		disableRipple
	>
		<mat-icon fontSet="fas" inline fontIcon="fa-info" />
	</button>
</div>
